
























































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import wizard from "./wizard.vue";
import FileReaderInput from "@/components/forms/FileReaderInput.vue";
import { validateEmail, validateMembers } from "../utils";
import { MemberToAdd } from "../types";
// import { parse } from 'papaparse'

@Component({
  components: {
    wizard,
    FileReaderInput
  }
})
export default class AddMembersForm extends Vue {
  @Prop({ default: [] }) private members!: Array<any>;
  @Prop() private file!: File;
  private hovering: boolean = false;
  private uploadSuccess: boolean = true;
  private hasUploaded: boolean = false;

  private created() {}

  private showErrorMessage() {
    for (var i = 0; i < this.members.length; i++) {
      if (this.members[i].valid === false) {
        return true;
      }
    }
    return false;
  }

  private handleLoad(text: any, file: File) {
    this.hasUploaded = true;

    if (text !== null && file !== null) {
      // if (file.type !== 'text/csv') {
      //   this.uploadSuccess = false;
      //   return;
      // }

      // this.uploadSuccess = true;

      // let output: Array<MemberToAdd> = [];
      // parse(file, {
      //   error: (err: any) => {
      //     console.log('CSV PARSE ERROR', err);
      //   },
      //   complete: (results: any, file: File) => {
      //     if (results.data && results.data.length) {
      //       for (var i = 0; i < results.data.length; ++i) {
      //         let record = results.data[i];

      //         if ((record.length === 1 && record[0] === '') ||
      //             (record.length === 3 && record[0] === '' &&
      //              record[1] === '' && record[2] === '')) {
      //           // Skip blank lines in CSV
      //           continue;
      //         } else if (record.length >= 3) {
      //           // Check for header
      //           if (i === 0 &&
      //               record[0].toLowerCase() === 'name' &&
      //               record[1].toLowerCase() === 'email' &&
      //               record[2].toLowerCase() === 'role') {
      //             continue;
      //           }

      //           let recordObj: any = {
      //             name: record[0],
      //             email: record[1],
      //             role: record[2]
      //           }

      //           output.push(recordObj);
      //         } else {
      //           this.uploadSuccess = false;
      //           break;
      //         }
      //       }
      //     }

      // if (this.uploadSuccess) {
      // if (validateMembers(output)) {
      this.$emit("uploaded", file, true);
      //   } else {
      //     this.uploadSuccess = false;
      //   }
      // }
      // console.log('PARSE', results, file)
      // }
      // })
    } else {
      this.hasUploaded = false;
      this.uploadSuccess = true;
      this.$emit("uploaded", null, false);
    }
  }
}
